import React from 'react';
import { Building2, FolderKanban, Table2, Activity, HardDrive } from 'lucide-react';
import { Card } from '../../../components/ui/Card';
import { formatFileSize } from '../../../utils/fileUrl';

interface HomeMetricsOverviewProps {
  organizationsCount: number;
  totalProjects: number;
  totalDatastores: number;
  totalSubmissionsThisMonth: number;
  totalStorageUsed: number;
}

export const HomeMetricsOverview: React.FC<HomeMetricsOverviewProps> = ({
  organizationsCount,
  totalProjects,
  totalDatastores,
  totalSubmissionsThisMonth,
  totalStorageUsed,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {/* Total Workspaces */}
      <Card className="p-4 bg-cf-surface border-cf-border space-y-1.5 shadow-xs">
        <div className="flex items-center justify-between text-cf-textSecondary">
          <span className="text-xs font-medium">Workspaces</span>
          <Building2 size={15} className="text-cf-textMuted" />
        </div>
        <div className="text-2xl font-bold text-cf-textPrimary tracking-tight">
          {organizationsCount}
        </div>
        <p className="text-xs text-cf-textSecondary">
          {organizationsCount === 1 ? 'Active organization' : 'Active organizations'}
        </p>
      </Card>

      {/* Total Projects */}
      <Card className="p-4 bg-cf-surface border-cf-border space-y-1.5 shadow-xs">
        <div className="flex items-center justify-between text-cf-textSecondary">
          <span className="text-xs font-medium">Total Projects</span>
          <FolderKanban size={15} className="text-cf-textMuted" />
        </div>
        <div className="text-2xl font-bold text-cf-textPrimary tracking-tight">
          {totalProjects}
        </div>
        <p className="text-xs text-cf-textSecondary">Organized across all workspaces</p>
      </Card>

      {/* Active Datastores */}
      <Card className="p-4 bg-cf-surface border-cf-border space-y-1.5 shadow-xs">
        <div className="flex items-center justify-between text-cf-textSecondary">
          <span className="text-xs font-medium">Active Datastores</span>
          <Table2 size={15} className="text-cf-textMuted" />
        </div>
        <div className="text-2xl font-bold text-cf-textPrimary tracking-tight">
          {totalDatastores}
        </div>
        <p className="text-xs text-cf-textSecondary">Forms &amp; webhook ingestion endpoints</p>
      </Card>

      {/* Monthly Responses Received */}
      <Card className="p-4 bg-cf-surface border-cf-border space-y-1.5 shadow-xs">
        <div className="flex items-center justify-between text-cf-textSecondary">
          <span className="text-xs font-medium">Responses This Month</span>
          <Activity size={15} className="text-cf-textMuted" />
        </div>
        <div className="text-2xl font-bold text-cf-textPrimary tracking-tight">
          {totalSubmissionsThisMonth.toLocaleString()}
        </div>
        <p className="text-xs text-cf-textSecondary">Ingested across all organizations</p>
      </Card>

      {/* Storage Used */}
      <Card className="p-4 bg-cf-surface border-cf-border space-y-1.5 shadow-xs">
        <div className="flex items-center justify-between text-cf-textSecondary">
          <span className="text-xs font-medium">Total Storage</span>
          <HardDrive size={15} className="text-cf-textMuted" />
        </div>
        <div className="text-2xl font-bold text-cf-textPrimary tracking-tight">
          {formatFileSize(totalStorageUsed)}
        </div>
        <p className="text-xs text-cf-textSecondary">Across all organizations</p>
      </Card>
    </div>
  );
};
